module.exports = __webpack_public_path__ + "static/media/GalanoGrotesque-Regular.0db105f8.otf";